import { useState, useEffect } from 'react'
import clsx from 'clsx'

import {
  Collapsible as SeragamCollapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from '@wartek-id/collapsible-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

type CollapsibleProps = {
  className?: string
  isOpen?: boolean
  title?: string | React.ReactNode
  triggerText?: {
    open: string
    close: string
  }
  children: React.ReactNode
}

export function Collapsible({
  isOpen: initialIsOpen = false,
  title,
  children,
  triggerText = {
    open: 'Tampilkan',
    close: 'Tutup',
  },
}: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(initialIsOpen)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    setIsOpen(initialIsOpen)
  }, [initialIsOpen])

  return (
    <SeragamCollapsible
      className="!border-0"
      open={isOpen}
      onToggle={handleToggle}
    >
      <div className="flex space-x-4 items-start">
        {title && <div className="w-full">{title}</div>}
        <CollapsibleTrigger className="!flex-grow-0 !w-auto !py-3">
          <Text variant="body-sm-bold" color="primary">
            {isOpen ? triggerText.close : triggerText.open}
          </Text>

          <Icon
            color="informational"
            className={clsx(
              'transition-transform duration-600',
              isOpen ? 'rotate-180' : ''
            )}
          >
            expand_more
          </Icon>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent>{children}</CollapsibleContent>
    </SeragamCollapsible>
  )
}
